import React from 'react';

import { Page, TableTabs } from 'components';
import { useSearchParams } from 'hooks/useSearchParams';
import { useTranslations } from 'hooks/useTranslations';

import { BusinessStatistics, CashflowStatistics, MrrStatistics } from './statistics';

// The organisations, reservations, users, providers and receipts tabs are taken
// out of the tab bar, so there is no way left to reach them. Their pages are
// still in ./statistics and still exported: this is a trial run, and they are
// only deleted once it is clear nobody misses them.
function StatisticsPage() {
  const translations = useTranslations('statisticsPage');

  const { searchParams, setSearchParams } = useSearchParams('statistics');

  const [tabIndex, setTabIndex] = React.useState(0);

  React.useEffect(() => {
    if (searchParams.tab) {
      setTabIndex(searchParams.tab);
    }
  }, [searchParams]);

  return (
    <Page name="statistics">
      <TableTabs
        variant="content"
        data={[
          { label: translations.business, content: <BusinessStatistics /> },
          { label: translations.mrr, content: <MrrStatistics /> },
          { label: translations.cashflow, content: <CashflowStatistics /> },
        ]}
        tabIndex={tabIndex}
        setTabIndex={(index) => {
          setSearchParams({ tab: index });
          setTabIndex(index);
        }}
      />
    </Page>
  );
}

export { StatisticsPage };
